import React from 'react';
const ProcessStripV2 = ({ copy }) => {
  if (!copy) return null;
  return (
    <section className="iv2-process" id="process" data-testid="iv2-process">
      <div className="iv2-container">
        <p className="iv2-section-eyebrow">{copy.eyebrow}</p>
        <h2 className="iv2-section-headline">{copy.headline}</h2>
        <p className="iv2-process-lede">{copy.lede}</p>
        <ol className="iv2-process-list">
          {copy.steps.map((s) => (
            <li key={s.id} className="iv2-process-step" data-testid={`iv2-process-step-${s.id}`}>
              <span className="iv2-process-step-label">{s.label}</span>
              <p className="iv2-process-step-body">{s.body}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};
export default ProcessStripV2;
